import DOMPurify from "dompurify";

// Shared DOMPurify helper for admin-authored rich text content.
// Allows only a very small, safe subset of inline styles so
// TipTap's font size/color/alignment survive while blocking
// dangerous or unexpected CSS.
export const sanitizeRichTextHtml = (html: string): string => {
    const allowedCssProps = ["color", "background-color", "font-size", "text-align"];

    DOMPurify.addHook("uponSanitizeAttribute", (_node, data) => {
        if (data.attrName !== "style" || typeof (data as any).attrValue !== "string") {
            return;
        }

        const cleaned = ((data as any).attrValue as string)
            .split(";")
            .map((decl: string) => decl.trim())
            .filter(Boolean)
            .map((decl: string) => {
                const [rawProp, ...rest] = decl.split(":");
                if (!rawProp || rest.length === 0) return null;
                const prop = rawProp.trim().toLowerCase();
                const val = rest.join(":").trim();

                if (!allowedCssProps.includes(prop)) return null;
                if (/expression|url\(/i.test(val)) return null;

                return `${prop}: ${val}`;
            })
            .filter(Boolean)
            .join("; ");

        if (!cleaned) {
            data.keepAttr = false;
        } else {
            (data as any).attrValue = cleaned;
        }
    });

    return DOMPurify.sanitize(html, {
        ALLOWED_ATTR: ["style", "href", "target", "rel"],
    });
};
